import { createStore, applyMiddleware } from 'redux';
import { NODE_ENV } from 'config';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { rootReducer } from 'helpers/reducers';

const loggerMiddleware = createLogger();

export const store =
  NODE_ENV === 'development'
    ? createStore(rootReducer, applyMiddleware(thunkMiddleware, loggerMiddleware))
    : createStore(rootReducer, applyMiddleware(thunkMiddleware));
